import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const BuyerTerms = () => {
  return (
    <div>
      <Navbar />
      <div style={{ minHeight: '100vh', backgroundColor: '#fff', paddingTop: '120px', paddingBottom: '60px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>
          <Link to="/" style={{ display: 'inline-block', marginBottom: '20px', color: '#dc2626', textDecoration: 'none', fontSize: '14px' }}>
            ← Back to Home
          </Link>
          
          <div style={{ backgroundColor: '#000', color: '#fff', padding: '30px', marginBottom: '30px', borderRadius: '8px' }}>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '10px' }}>Buyer Terms & Conditions</h1>
            <p style={{ opacity: 0.9 }}>ARTCARDO Purchase Policy</p>
            <p style={{ opacity: 0.7, marginTop: '10px' }}>Effective from: January 2025</p>
          </div>

          <div style={{ backgroundColor: '#f9fafb', padding: '30px', borderRadius: '8px', lineHeight: '1.8' }}>
            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>1. Introduction</h2>
              <p style={{ color: '#374151' }}>
                Welcome to ARTCARDO ("Platform"), an online marketplace owned and operated by MAXRAD SOFTWARE INDIA PVT LTD (Brand name ARTCARDO under the division DULCIA.ART), having its registered office at 1542, 17th B, Main, 5th Block, HBR Layout, Bangalore - 560043, Karnataka, India ("Company", "We", "Us", "Our"). These Terms & Conditions ("Terms" or "Agreement") govern your access and purchase of artworks, handicrafts, and related creative products ("Products") from artists and artisans ("Sellers") through ARTCARDO.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>2. Eligibility</h2>
              <p style={{ color: '#374151' }}>
                You must be at least 18 years of age and capable of entering into a legally binding contract under the Indian Contract Act, 1872.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>3. Platform Role & Limitation of Liability</h2>
              <p style={{ color: '#374151' }}>
                ARTCARDO is a facilitator providing a digital platform where independent Sellers list and sell their creative products directly to Buyers. The contract of sale is between the Seller and the Buyer.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>4. Pricing, Taxes & Payments</h2>
              <p style={{ color: '#374151' }}>
                All prices are listed in Indian Rupees (INR). ARTCARDO supports all major online payment modes. Cash on Delivery (COD) is not available.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>5. Returns & Refunds</h2>
              <p style={{ color: '#374151' }}>
                Returns are accepted within 5 days of delivery for production defects only. Photographic evidence is required.
              </p>
            </section>

            <section style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.75rem', fontWeight: 'bold', color: '#000', marginBottom: '15px' }}>6. Contact Information</h2>
              <p style={{ color: '#374151' }}><strong>MAXRAD SOFTWARE INDIA PVT LTD</strong></p>
              <p style={{ color: '#374151' }}>(Brand name ARTCARDO under the division DULCIA.ART)</p>
              <p style={{ color: '#374151' }}>Email: <a href="mailto:dulciaart@gmail.com" style={{ color: '#dc2626', textDecoration: 'underline' }}>dulciaart@gmail.com</a></p>
              <p style={{ color: '#374151' }}>Phone: <a href="tel:+919019028615" style={{ color: '#dc2626', textDecoration: 'underline' }}>+91 90190 28615</a></p>
              <p style={{ color: '#374151' }}>Address: 1542, 17th B, Main, 5th Block, HBR Layout, Bangalore - 560043, Karnataka, India</p>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BuyerTerms;
